import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class BaseProvider {
  constructor(
    private readonly alertCtrl: AlertController,
    private readonly translocoService: TranslocoService
  ) {}

  async popupAlert(header: string, message: string, handler?: () => void) {
    const alert = await this.alertCtrl.create({
      header,
      message,
      cssClass: 'alert-message',
      backdropDismiss: !handler,
      buttons: [
        {
          text: this.translocoService.translate('common.ok'),
          role: 'ok',
          handler: () => {
            if (handler) {
              handler();
            }
          }
        }
      ]
    });
    alert.present();
  }

  async popupConfirm(title, message, yesHandler, noHandler?) {
    const confirm = await this.alertCtrl.create({
      header: title,
      message,
      buttons: [
        {
          text: this.translocoService.translate('common.no'),
          role: 'cancel',
          handler: () => {
            if (noHandler) {
              noHandler();
            }
          }
        },
        {
          text: this.translocoService.translate('common.yes'),
          role: 'ok',
          handler: () => {
            if (yesHandler) {
              yesHandler();
            }
          }
        }
      ]
    });
    confirm.present();
  }

  paymentClick() {}
}
